import React, { useEffect, useState } from "react";
import { Card } from "flowbite-react";
import { MapPinIcon, HomeIcon, User, CircleUser } from "lucide-react";
import NoAddressesMessage from "./NoAddressesMessage";
import EndCustomerDetails from "./EndCustomerDetails";

const fields = [
  {
    key: "Company_Name",
    label: "Address 1",
    icon: <HomeIcon className="inline mr-2" />,
  },
  {
    key: "Address_2",
    label: "Address 2",
    icon: <MapPinIcon className="inline mr-2 h-4 aspect-square" />,
  },
  {
    key: "City",
    label: "City",
    icon: <MapPinIcon className="inline mr-2 h-4 aspect-square" />,
  },
  {
    key: "State",
    label: "State",
    icon: <MapPinIcon className="inline mr-2 h-4 aspect-square" />,
  },
  {
    key: "Country",
    label: "Country",
    icon: <MapPinIcon className="inline mr-2 h-4 aspect-square" />,
  },
  {
    key: "Postal_Code",
    label: "Postal Code",
    icon: <MapPinIcon className="inline mr-2 h-4 aspect-square" />,
  },
];

const AddressList = ({ addresses, viewMode, type }) => {
  const [endCustomer, setEndCustomer] = useState(false);
  // console.log(viewMode);
  // console.log(addresses);

  useEffect(() => {
    if (addresses[0]?.Address_Type === "End Customer") {
      setEndCustomer(true);
    } else {
      setEndCustomer(false);
    }
  }, [addresses]);

  console.log(endCustomer);
  console.log(type);
  if (!addresses || addresses.length === 0) {
    return <NoAddressesMessage type={type} />;
  }

  return viewMode === "table" ? (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            {endCustomer && (
              <>
                <th key="Company_Name2" className="px-6 py-3 font-semibold">
                  Company Name
                </th>
                <th key="Name" className="px-6 py-3 font-semibold">
                  Customer Name
                </th>
              </>
            )}

            {fields.map((field) => (
              <th key={field.key} className="px-6 py-3 font-semibold">
                {field.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {addresses.map((address) => (
            <tr
              key={address.id}
              className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
            >
              {endCustomer && (
                <>
                  <td className={`px-6 py-4 break-words flex items-center gap-2`} >
                    <EndCustomerDetails
                      customerId={address.End_Customer?.id}
                      viewMode={viewMode}
                    />
                    {address?.End_Customer_Company_Name || "N/A"}
                  </td>
                  <td className={`px-6 py-4 break-words`}>
                    {address.End_Customer?.name || "N/A"}
                  </td>
                </>
              )}
              {fields.map((field) => (
                <td
                  key={field.key}
                  className={`px-6 py-4 break-words ${
                    field.key === "Company_Name" ? "font-bold" : ""
                  }`}
                >
                  {address[field.key] || "N/A"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {addresses.map((address) => (
        <Card
          key={address.id}
          className="max-w-sm hover:shadow-lg transition-shadow duration-200 p-4"
        >
          {endCustomer && (
            <>
              <EndCustomerDetails
                customerId={address.End_Customer?.id}
                viewMode={viewMode}
              />
              <h4 className="text-lg text-gray-700 dark:text-gray-400 mb-1">
                {address.End_Customer_Company_Name}
              </h4>
              <h5 className="font-lg text-gray-700 dark:text-gray-400 mt-[-18px]">
                {address.End_Customer?.name}
              </h5>
              {/* <p className="font-normal text-gray-700 dark:text-gray-400">
                <CircleUser className="inline mr-2 h-8 aspect-square" />
                <span className="font-medium">Customer Name:</span>{" "}
                {address.End_Customer?.name || "N/A"}
              </p> */}
            </>
          )}
          <h5 className="text-normal font-medium tracking-tight text-gray-700 dark:text-white">
            {fields[0].icon}
            {address[fields[0].key]}
          </h5>

          {/* {
          fields.slice(1).map((field) => (
            <p
              key={field.key}
              className="font-normal text-gray-700 dark:text-gray-400"
            >
              {field.icon}
              {field.label}: {address[field.key] || "N/A"}
            </p>
          ))} */}
          <>
            {/* Render extra fields when endCustomer is true */}

            {/* Render remaining fields */}
            {fields.slice(1).map((field) => (
              <p
                key={field.key}
                className="font-normal text-gray-700 dark:text-gray-400"
              >
                {field.icon}
                {field.label}: {address?.[field.key] || "N/A"}
              </p>
            ))}
          </>
        </Card>
      ))}
    </div>
  );
};

export default AddressList;
